"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const Divider_styles_1 = require("./Divider.styles");
const QlubDivider = ({ type, sx, text }) => {
    const { dividerStyle } = (0, Divider_styles_1.default)({ type });
    return (0, jsx_runtime_1.jsx)(material_1.Box, { sx: (0, merge_1.merge)(dividerStyle, sx), children: text && (0, jsx_runtime_1.jsx)("p", { children: text }) });
};
exports.default = QlubDivider;
